/**
 * Based on https://github.com/kopterio/vue-auth-cognito
 */
import ActionsFactory from './actions'
import mutations from './mutations'

const state = {
  user: null,
  user_auth_challenge: null
}

// Example state
// const state = {
//   user: {
//     username: 'username in any format: email, UUID, etc.',
//     tokens: null | {
//       IdToken: '', // in JWT format
//       RefreshToken: '', // in JWT format
//       AccessToken: '', // in JWT format
//     },
//     attributes: {
//       email: 'user email',
//       phone_number: '+1 555 12345',
//       ...
//     }
//   },
// };

export default class CognitoAuth {
  constructor (config) {
    // this.namespaced = true
    this.state = state
    this.actions = new ActionsFactory(config)
    this.mutations = mutations
  }
}
